import React from 'react';
import { Link } from 'react-router-dom';
import { RefreshCw } from 'lucide-react';

export default function PageHeader() {
  return (
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center space-x-2">
            <RefreshCw className="w-6 h-6 text-indigo-600" />
            <span className="text-lg font-semibold">4D SEAMLESS EMR</span>
          </Link>
          <nav className="flex items-center space-x-4">
            <Link to="/docs" className="text-gray-500 hover:text-gray-900">
              Documentation
            </Link>
            <Link to="/login" className="text-gray-500 hover:text-gray-900">
              Sign In
            </Link>
            <Link
              to="/demo"
              className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700"
            >
              GET DEMO
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
